// Copied verbatim from
// `cg-dark-refunds/platform/src/components/refunds-agent/constants.ts`
// so the Form Spam setup screen speaks the Refunds Agent's language.

/** Knowledge base article for the form protection code. */
export const FORM_SPAM_KB_URL =
	'https://docs.clickguard.com/en/articles/21430-how-to-install-the-clickguard-tracking-code'

/**
 * R322 (Gustavo, 13 Sep): the wizard's "Watch tutorial" button. No tutorial
 * video exists yet, so the button opens the same knowledge base article
 * until product hands over the real link. Swap the string, nothing else.
 *
 * R334 (Esteban, 14 Sep): "we keep the 'watch tutorial' button and get rid of
 * the 'see documentation' one". That button is now the ONE entry to the docs
 * page from the wizard; the rail's See documentation link is gone. The KB
 * article will host the tutorial too, so the two URLs stay the same until
 * product hands over a separate video link.
 */
export const FORM_SPAM_TUTORIAL_URL = FORM_SPAM_KB_URL

/**
 * Two CTA colour systems — do NOT unify (B0). Lime accent for setup/connect CTAs.
 * Radius 8px + SemiBold + lime glow shadow match the Figma DS button.
 */
export const LIME_CTA_CLASS =
	'rounded-[8px] font-semibold bg-b-yellow border border-b-yellow-dark text-on-lemon hover:brightness-95 shadow-s-yellow'
